import { Direction, createTheme, Theme } from '@mui/material/styles';
// import { purple } from '@mui/material/colors';

declare module '@mui/material/styles' {
  interface Palette {
    telegram: Palette['primary'];
    whatsapp: Palette['primary'];
    viber: Palette['primary'];
  }

  interface PaletteOptions {
    telegram?: PaletteOptions['primary'];
    whatsapp?: PaletteOptions['primary'];
    viber?: PaletteOptions['primary'];
  }
}

const theme = createTheme();

type Options = {
  direction: Direction;
};

export default function getTheme({ direction }: Options): Theme {
  const { white } = theme.palette.common;
  const { fontWeightBold, fontWeightMedium } = theme.typography;

  return {
    ...theme,
    direction,
    typography: {
      ...theme.typography,
      // fontFamily: '',
      // fontSize: 16,
      // h1: {},
      h2: {
        fontWeight: fontWeightBold,
      },
      h3: {
        fontWeight: fontWeightBold,
      },
      h4: {
        fontWeight: fontWeightBold,
      },
      h5: {
        fontWeight: fontWeightBold,
      },
      h6: {
        fontWeight: fontWeightBold,
      },
      subtitle1: {
        fontWeight: fontWeightMedium,
      },
      // subtitle2: {},
      // body1: {},
      // body2: {},
      // caption: {},
      // button: {},
      // overline: {},
    },
    // shadows: [
    //   // ...theme.shadows,
    // ],
    palette: {
      ...theme.palette,
      mode: 'dark',
      primary: {
        main: '#212121',
        light: '#484848',
        dark: '#000000',
        contrastText: white,
      },
      secondary: {
        main: '#bdbdbd',
        light: '#efefef',
        dark: '#8d8d8d',
        contrastText: white,
      },
      // text: {},
      telegram: {
        main: '#0088cc',
        light: '#5cb8ff',
        dark: '#005b9b',
        contrastText: white,
      },
      whatsapp: {
        main: '#4FCE5D',
        light: '#86ff8d',
        dark: '#009c2f',
        contrastText: white,
      },
      viber: {
        main: '#665CAC',
        light: '#9789de',
        dark: '#36327c',
        contrastText: white,
      },
    },
  };
}
